import { UploadFile } from 'antd';

export type DocumentType =
  | UploadFile
  | { file: UploadFile | null; expiredDate: string | null };

export enum UserStatus {
  REGISTRATION = 'На регистрации', // доступна возможность редактировать анкету и документы
  CONFIRMATION = 'На подтверждении', // менеджер проверяет документы
  IN_SURVEY = 'На анкетировании', // документы проверены, можно проходить тестирование
  ACTIVE = 'Работает', // тестирование пройдено, пользователь активен (раздел регистрации не доступен)
  DISABLED = 'Отключён', // видимо, пользователь заблокирован (раздел регистрации не доступен)
  SIGN_CONTRACT = 'На подписании договора', // Пользователь прошел регистрацию и тест, нужно подписать договор
}

export enum DocTypeClass {
  USUAL = '',
  PHOTO = 'Фото с паспортом',
  SIGNED_CONTRACT = 'Договор подписанный',
  NOT_SIGNED_CONTRACT = 'Договор не подписанный',
}

export type WorksheetData = {
  // Legal
  fullNameRu?: string;
  fullNameEn?: string;
  shortNameEn?: string;
  shortNameRu?: string;
  countryId?: string;
  inn?: string;
  regNumber?: string;
  regDate?: string;
  registrationAuthorityRu?: string;
  registrationAuthorityEn?: string;
  addressRu?: string;
  addressEn?: string;
  eMail?: string;
  phone?: string;
  basisRuGC?: string;
  basisEn?: string;
  signatoryRu?: string;
  signatoryRuGC?: string;
  signatoryEn?: string;
  signatoryPositionRu?: string;
  signatoryPositionRuGC?: string;
  signatoryPositionEn?: string;
  status?: UserStatus;
  eMailOrganization?: string;

  // Individual + часть из Legal
  indFamily?: string;
  indName?: string;
  indSurname?: string;
  indFamilyEn?: string;
  indNameEn?: string;
  indSurnameEn?: string;
  identityDocument?: string;
  identityDocumentEn?: string;
  actualAddressRu?: string;
  actualAddressEn?: string;
  publicOfficial?: string;

  // ИП
  registrationLocationRu?: string;
  registrationLocationEn?: string;
};

export interface DocUploadedUser {
  validTo?: string;
  comment?: string;
  docTypeId?: string;
  docTypeName?: string;
  number?: string;
  date?: string;
  fileId?: string;
  fileName?: string;
  name?: string;
  docTypeClass?: DocTypeClass;
  blocked?: boolean;
}

export interface UserInfo {
  name: string;
  fullNameEn: string;
  passwordChangeRequired?: boolean;
  docs: DocUploadedUser[];
  legalEntity: LegalStatus;
  countryId: string;
  countryName: string;
  fullNameRu: string;
  inn: string;
  shortNameEn: string;
  shortNameRu: string;
  regNumber: string;
  regDate: string;
  registrationAuthorityRu: string;
  registrationAuthorityEn: string;
  addressRu: string;
  addressEn: string;
  eMail: string;
  phone: string;
  basisRuGC: string;
  basisEn: string;
  signatoryRu: string;
  signatoryRuGC: string;
  signatoryEn: string;
  signatoryPositionRu: string;
  signatoryPositionRuGC: string;
  signatoryPositionEn: string;
  status: UserStatus;
  eMailOrganization: string;
  legalStatus: LegalStatus;

  indFamily?: string;
  indName?: string;
  indSurname?: string;
  indFamilyEn?: string;
  indNameEn?: string;
  indSurnameEn?: string;
  identityDocument?: string;
  identityDocumentEn?: string;
  actualAddressRu?: string;
  actualAddressEn?: string;
  publicOfficial?: string;

  // ИП
  registrationLocationRu?: string;
  registrationLocationEn?: string;
}
export type UserInfoDto = Omit<
  UserInfo,
  'name' | 'docs' | 'countryId' | 'passwordChangeRequired'
>;

export enum LegalStatus {
  INDIVIDUAL = 'Физ. лицо',
  LEGAL = 'Юр. лицо',
  INDIVIDUAL_ENTREPRENEUR = 'ИП',
}
